import { Button, type ButtonProps } from "@ui/primitives/Button";
import { composeRenderProps } from "@ui/primitives/shared";
import type { ReactNode } from "react";
import { type ActionPillItemVariants, actionPillItem } from "./action-pill-item.styles";

export type ActionPillButtonProps = ButtonProps & {
  hoverColor?: ActionPillItemVariants["hoverColor"];
  icon: ReactNode;
  size?: ActionPillItemVariants["size"];
};

export function ActionPillButton({ hoverColor = "yellow", icon, size, ...props }: ActionPillButtonProps) {
  return (
    <Button
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        actionPillItem({ ...renderProps, hoverColor, size, className }),
      )}
    >
      {composeRenderProps(props.children, (children) => (
        <>
          <span aria-hidden="true" className="inline-flex shrink-0">
            {icon}
          </span>
          {children}
        </>
      ))}
    </Button>
  );
}
